import { GET_ORDER_BILLING_INFO } from '../actionTypes/OrderActionTypes';

export default function OrderBillingInfoReducer(state = {}, action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case GET_ORDER_BILLING_INFO:
            return { ...action.payload };
        default:
            return state;
    }
}
